import React from "react";
import {useTranslation} from "react-i18next";


const ScheduleListItem = ({ id, date, title, onDate}) => {

    const {t} = useTranslation();
    return (<>
        <div id={id}
            className={"bg-white grid grid-cols-1 rounded shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] sm:grid-cols-6 py-3 px-4"}>
            <div className={"flex flex-col"}>
                <p className={"uppercase text-sm text-gray-400 hidden sm:block"}>{t('schedule.list.subTitle')}</p>
                <p className={"font-bold text-gray-400 sm:text-black"}>{date}</p>
            </div>
            <div className={"col-span-5 my-auto"}>
                <p className={"font-bold m-auto"}>{title + " " + onDate + " " + t('schedule.month')}</p>
            </div>
        </div>
    </>)
}

export default ScheduleListItem;